import { useContext } from 'react';
import useSWR from 'swr';

import { cartContext } from 'contexts/cartContext';
import { fetcher } from 'services/fetcher';
import { ENV_API_KEY_SYMFONY, ENV_API_URL_CHECKOUT } from 'settings/env';
import { Cart } from 'types/Cart';

type ReturnType = {
  paymentMethods?: string[];
  updatePaymentMethod: (
    paymentMethod?: string,
    additionalOptions?: RequestInit
  ) => Promise<Cart | undefined>;
};

export default function useCartPayment(): ReturnType {
  const { mutateCart } = useContext(cartContext);
  const { data: paymentMethods } = useSWR(
    `${ENV_API_URL_CHECKOUT}/cart/payment/get`,
    fetcher
  );

  return {
    paymentMethods,
    updatePaymentMethod: async (
      paymentMethod?: string,
      additionalOptions?: RequestInit
    ) => {
      const response = await fetch(
        `${ENV_API_URL_CHECKOUT}/cart/payment/update`,
        {
          method: 'POST',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
            'X-AUTH-TOKEN': `${ENV_API_KEY_SYMFONY}`,
          },
          body: JSON.stringify({
            paymentMethod: paymentMethod ?? null,
          }),
          ...(additionalOptions || {}),
        }
      );

      const data = await response.json();

      if (!response.ok) {
        console.error(data.message);

        return Promise.reject(data);
      }

      mutateCart(data || []);

      return Promise.resolve(data);
    },
  };
}
